export default "__VITE_ASSET__RyWGltFr__"